/* ============================================================
 * Formulário com imagem — Rosa Selvagem
 *
 * O app Shopify Forms desenha o formulário dentro de
 * <shopify-forms-embed>, um custom element com SHADOW DOM.
 *
 * Consequência prática: CSS escrito no tema NÃO atravessa essa fronteira —
 * é por isso que arredondar os campos de fora nunca funcionou. JavaScript
 * atravessa, porque o shadow root é aberto. Então tudo aqui entra por
 * host.shadowRoot: o estilo é injetado lá dentro, e os campos são lidos
 * de lá.
 *
 * O envio para a Shopify continua sendo do app. Só lemos de passagem.
 * ============================================================ */
(function () {
  'use strict';

  var DEBUG = /[?&]wa_debug=1/.test(window.location.search);
  function log() {
    if (DEBUG && window.console) console.log.apply(console, ['[form-atacado]'].concat([].slice.call(arguments)));
  }

  /* ---- Escrever num campo controlado por framework ----
     O app é uma aplicação React: atribuir campo.value direto não avisa o
     estado interno, e a próxima renderização desfaz o que escrevemos. O
     caminho é usar o setter nativo do protótipo e então disparar o evento
     que o framework escuta. */
  function escreverValor(campo, valor) {
    var proto = campo instanceof window.HTMLTextAreaElement
      ? window.HTMLTextAreaElement.prototype
      : window.HTMLInputElement.prototype;
    var setter = Object.getOwnPropertyDescriptor(proto, 'value');
    if (setter && setter.set) setter.set.call(campo, valor);
    else campo.value = valor;
    campo.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
  }

  /* ---- Máscara de CNPJ ---- */
  function formatarCnpj(valor) {
    var d = (valor || '').replace(/\D/g, '').slice(0, 14);
    if (d.length <= 2) return d;
    if (d.length <= 5) return d.slice(0, 2) + '.' + d.slice(2);
    if (d.length <= 8) return d.slice(0, 2) + '.' + d.slice(2, 5) + '.' + d.slice(5);
    if (d.length <= 12) return d.slice(0, 2) + '.' + d.slice(2, 5) + '.' + d.slice(5, 8) + '/' + d.slice(8);
    return d.slice(0, 2) + '.' + d.slice(2, 5) + '.' + d.slice(5, 8) + '/' + d.slice(8, 12) + '-' + d.slice(12);
  }

  function acharCnpj(sr) {
    var campos = sr.querySelectorAll('input');
    for (var i = 0; i < campos.length; i++) {
      var c = campos[i];
      var texto = [c.id, c.name, c.placeholder, c.getAttribute('aria-label')].join(' ');
      var rot = c.id ? sr.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(c.id) : c.id) + '"]') : null;
      if (rot) texto += ' ' + rot.textContent;
      if (/cnpj/i.test(texto)) return c;
    }
    return null;
  }

  function ligarMascaraCnpj(sr) {
    var campo = acharCnpj(sr);
    if (!campo || campo.dataset.faCnpj) return;
    campo.dataset.faCnpj = '1';

    // Num input[type=number] o navegador recusa "12.345.678/0001-99" e apaga
    // o campo — a máscara nunca sobrevive. Por isso ele vira texto.
    if ((campo.getAttribute('type') || '').toLowerCase() === 'number') {
      campo.setAttribute('type', 'text');
      log('campo CNPJ era type=number; convertido para text');
    }
    campo.setAttribute('inputmode', 'numeric');
    campo.setAttribute('maxlength', '18');
    campo.setAttribute('autocomplete', 'off');

    var ocupado = false;
    campo.addEventListener('input', function () {
      if (ocupado) return;                       // nosso próprio evento volta aqui
      var bruto = campo.value;
      var formatado = formatarCnpj(bruto);
      if (formatado === bruto) return;

      var digitosAntes = bruto.slice(0, campo.selectionStart || 0).replace(/\D/g, '').length;
      ocupado = true;
      escreverValor(campo, formatado);
      ocupado = false;

      var pos = 0, contados = 0;
      while (pos < campo.value.length && contados < digitosAntes) {
        if (/\d/.test(campo.value[pos])) contados++;
        pos++;
      }
      try { campo.setSelectionRange(pos, pos); } catch (e) {}
    });
    log('máscara de CNPJ ligada');
  }

  /* ---- Aparência: o estilo precisa morar DENTRO do shadow ---- */
  function vestir(sr, raiz) {
    if (sr.getElementById && sr.getElementById('fa-estilo')) return;
    var campo = raiz.dataset.fieldRadius || '26';
    var botao = raiz.dataset.buttonRadius || '100';
    var borda = raiz.dataset.fieldBorder || 'rgba(226,148,170,.45)';
    var foco = raiz.dataset.accent || '#E294AA';

    var fonte = raiz.dataset.fieldFont || '15';
    var fonteMob = raiz.dataset.fieldFontMobile || '16';

    var css = document.createElement('style');
    css.id = 'fa-estilo';
    // As classes do app têm hash (_formInputField_nag3b_7) e mudam a cada
    // versão dele, então miramos por tag e tipo, que são estáveis.
    css.textContent =
      'input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]),' +
      'select, button[role="combobox"], [class*="selectToggle"], [class*="PhoneInput"], [class*="phoneInput"] {' +
      '  border-radius: ' + campo + 'px !important;' +
      '  border-color: ' + borda + ' !important;' +
      '}' +
      'textarea { border-radius: 18px !important; }' +
      'input:focus, select:focus, textarea:focus, button[role="combobox"]:focus {' +
      '  outline: none !important;' +
      '  border-color: ' + foco + ' !important;' +
      '  box-shadow: 0 0 0 3px ' + foco + '2e !important;' +
      '}' +
      'button[type="submit"] { border-radius: ' + botao + 'px !important; }' +
      // O app limita a largura por dentro (um container de 450px e wrappers com
      // recuo), o que deixa os campos estreitos dentro da caixa. Aqui eles voltam
      // a ocupar o espaço todo. Os nomes de classe têm hash, mas o prefixo é estável.
      '[class*="_appEmbedRoot_"], [class*="_container_"], [class*="_inline_"],' +
      '[class*="_formContainer_"], [class*="_gridItem_"], [class*="_formFieldset_"],' +
      '[class*="_formFieldContainer_"] {' +
      '  max-width: 100% !important; width: 100% !important;' +
      '  margin-left: 0 !important; margin-right: 0 !important;' +
      '}' +
      // Esses wrappers são grid com justify-content:center — num grid centralizado
      // a coluna encolhe até o conteúdo em vez de ocupar a linha.
      '[class*="_container_"], [class*="_inline_"], [class*="_formContainer_"] {' +
      '  grid-template-columns: 1fr !important;' +
      '  justify-content: stretch !important;' +
      '  justify-items: stretch !important;' +
      '  overflow: visible !important;' +
      '}' +
      'input, textarea, select, button { font-size: ' + fonte + 'px !important; }' +
      '@media (max-width: 767px) {' +
      '  input, textarea, select, button { font-size: ' + fonteMob + 'px !important; }' +
      '  input, select { padding-top: 24px !important; padding-bottom: 8px !important; }' +
      '}';
    sr.appendChild(css);
    log('estilo injetado no shadow DOM');
  }

  /* ---- Mensagens do app em português ---- */
  var FRASES = [
    [/^First name is required\.?$/i, 'Informe seu nome'],
    [/^Last name is required\.?$/i, 'Informe seu sobrenome'],
    [/^Phone number is required\.?$/i, 'Informe seu WhatsApp'],
    [/^Email is required\.?$/i, 'Informe seu e-mail'],
    [/^(This )?[Ff]ield is required\.?$/i, 'Campo obrigatório'],
    [/^Please enter a valid email( address)?\.?$/i, 'Digite um e-mail válido'],
    [/^Please enter a valid phone number\.?$/i, 'Digite um número de WhatsApp válido'],
    [/^Enter a valid email\.?$/i, 'Digite um e-mail válido'],
    [/^Maximum allowed value is .+$/i, 'Valor acima do permitido'],
    [/^Minimum allowed value is .+$/i, 'Valor abaixo do permitido'],
    [/^Maximum length is (\d+).*$/i, 'Use no máximo $1 caracteres'],
    [/^Please select an option\.?$/i, 'Escolha uma opção'],
    [/^Something went wrong\.?.*$/i, 'Algo deu errado. Tente novamente.'],
    [/^Please complete the captcha\.?$/i, 'Confirme que você não é um robô']
  ];

  function traduzirNo(no) {
    if (no.nodeType !== 3) return;                      // só nós de texto
    var t = (no.nodeValue || '').trim();
    if (!t || !/[a-z]/i.test(t)) return;
    for (var i = 0; i < FRASES.length; i++) {
      if (FRASES[i][0].test(t)) {
        var novo = t.replace(FRASES[i][0], FRASES[i][1]);
        if (novo !== no.nodeValue) no.nodeValue = novo;
        return;
      }
    }
  }

  function traduzirTudo(raizNo) {
    var it = document.createTreeWalker(raizNo, NodeFilter.SHOW_TEXT, null);
    var n, lista = [];
    while ((n = it.nextNode())) lista.push(n);
    lista.forEach(traduzirNo);
  }

  /* ---- Leitura dos campos para o WhatsApp ---- */
  var IGNORAR = /(^_|utm|token|csrf|honeypot|captcha|recaptcha)/i;

  function rotuloDe(campo, sr) {
    if (campo.id) {
      var l = sr.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(campo.id) : campo.id) + '"]');
      if (l && l.textContent.trim()) return l.textContent.trim();
    }
    var pai = campo.closest('label');
    if (pai && pai.textContent.trim()) return pai.textContent.trim();
    if (campo.getAttribute('aria-label')) return campo.getAttribute('aria-label').trim();
    if (campo.placeholder) return campo.placeholder.trim();
    return (campo.id || campo.name || 'Campo').replace(/^custom#/, '').replace(/[_\-]+/g, ' ').trim();
  }

  function codigoDoPais(sr) {
    var bt = sr.querySelector('button[aria-label*="Country code"]');
    var m = bt && (bt.getAttribute('aria-label') || '').match(/\+(\d+)/);
    return m ? m[1] : '55';
  }

  // O app entrega o telefone grudado, como "+55 11987654321"; deixamos legível.
  function formatarTelefone(valor, pais) {
    var d = (valor || '').replace(/\D/g, '');
    if (!d) return '';
    pais = pais || '55';
    if (d === pais) return '';                      // só o prefixo, nada digitado
    if (d.slice(0, pais.length) === pais && d.length > pais.length) d = d.slice(pais.length);
    if (!d) return '';
    if (pais !== '55') return '+' + pais + ' ' + d;
    if (d.length !== 10 && d.length !== 11) return valor.trim();
    var ddd = d.slice(0, 2), resto = d.slice(2);
    var meio = resto.length === 9 ? resto.slice(0, 5) + '-' + resto.slice(5)
             : resto.length === 8 ? resto.slice(0, 4) + '-' + resto.slice(4)
             : resto;
    if (!ddd) return valor;
    return '+' + pais + ' (' + ddd + ') ' + meio;
  }

  // Estado e afins são botões de seleção, não <select>.
  function coletarSelecoes(sr) {
    var linhas = [];
    sr.querySelectorAll('button[class*="electToggle"], button[role="combobox"]').forEach(function (bt) {
      if (/country code/i.test(bt.getAttribute('aria-label') || '')) return;   // o do país já vai no telefone
      var escolha = (bt.textContent || '').trim();
      if (!escolha) return;

      var rotulo = '';
      var aponta = bt.getAttribute('aria-labelledby');
      if (aponta) {
        aponta.split(/\s+/).forEach(function (id) {
          if (rotulo || /value$/i.test(id)) return;                  // "-value" é a escolha, não o rótulo
          var el = sr.getElementById ? sr.getElementById(id) : sr.querySelector('[id="' + id + '"]');
          if (el && el.textContent.trim()) rotulo = el.textContent.trim();
        });
      }
      // sem aria-labelledby, aceitamos um <label> só se o container tiver um único campo
      if (!rotulo) {
        var n = bt;
        for (var i = 0; i < 3 && n && !rotulo; i++) {
          n = n.parentElement;
          if (!n) break;
          var labels = n.querySelectorAll('label');
          if (labels.length === 1 && n.querySelectorAll('input, button, select').length <= 2) {
            rotulo = labels[0].textContent.trim();
          }
        }
      }
      var chave = (aponta || '').split(/\s+/)[0] || rotulo || escolha;
      linhas.push({
        chave: chave,
        rotulo: (rotulo || 'Opção').replace(/\s*\*+\s*$/, '').replace(/:$/, ''),
        valor: escolha
      });
    });
    return linhas;
  }

  function coletar(sr) {
    var linhas = [];
    sr.querySelectorAll('input, textarea, select').forEach(function (campo) {
      var tipo = (campo.getAttribute('type') || '').toLowerCase();
      if (tipo === 'hidden' || tipo === 'submit' || tipo === 'button') return;
      var chave = (campo.id || campo.name || '');
      if (IGNORAR.test(chave)) return;

      var valor = '';
      if (tipo === 'checkbox') { if (!campo.checked) return; valor = 'Sim'; }
      else if (tipo === 'radio') { if (!campo.checked) return; valor = campo.value; }
      else valor = (campo.value || '').trim();
      if (!valor) return;

      if (tipo === 'tel') valor = formatarTelefone(valor, codigoDoPais(sr));
      if (!valor) return;
      var rotulo = rotuloDe(campo, sr).replace(/\s*\*+\s*$/, '').replace(/:$/, '');
      linhas.push({ chave: chave || rotulo, rotulo: rotulo, valor: valor });
    });
    return linhas.concat(coletarSelecoes(sr));
  }

  function montarLink(raiz, linhas) {
    var numero = (raiz.dataset.waNumber || '').replace(/\D/g, '');
    if (!numero) return '';
    // abertura, os dados em bloco, e o fecho — separados por linha em branco
    var dados = linhas.map(function (l) { return l.rotulo + ': ' + l.valor; }).join('\n');
    var texto = [raiz.dataset.waIntro || '', dados, raiz.dataset.waOutro || '']
      .filter(function (p) { return p && p.trim(); }).join('\n\n');
    return 'https://wa.me/' + numero + '?text=' + encodeURIComponent(texto);
  }

  /* ---- Montagem ---- */
  function comShadow(raiz, pronto) {
    var tentativas = 0;
    function tenta() {
      var host = raiz.querySelector('shopify-forms-embed');
      var sr = host && host.shadowRoot;
      if (sr && sr.querySelector('form')) { pronto(sr); return true; }
      return false;
    }
    if (tenta()) return;
    // o app monta o shadow sem mutar o host, então observar não basta: verificamos
    var t = setInterval(function () {
      if (tenta() || ++tentativas > 75) clearInterval(t);   // ~30s
    }, 400);
  }

  function ligar(raiz) {
    if (raiz.dataset.faLigado) return;
    raiz.dataset.faLigado = '1';
    var aviso = raiz.querySelector('[data-fa-wa]');
    var link = raiz.querySelector('[data-fa-wa-link]');

    comShadow(raiz, function (sr) {
      log('shadow DOM encontrado, campos:', sr.querySelectorAll('input,select,textarea').length);
      vestir(sr, raiz);
      ligarMascaraCnpj(sr);
      traduzirTudo(sr);

      var memoria = [];
      function guardar() {
        coletar(sr).forEach(function (linha) {
          for (var i = 0; i < memoria.length; i++) {
            if (memoria[i].chave === linha.chave) { memoria[i] = linha; return; }
          }
          memoria.push(linha);
        });
        log('memória:', memoria.map(function (l) { return l.rotulo + '=' + l.valor; }).join(' | '));
      }
      sr.addEventListener('input', guardar, true);
      sr.addEventListener('change', guardar, true);
      sr.addEventListener('blur', guardar, true);
      sr.addEventListener('submit', guardar, true);
      sr.addEventListener('click', function (e) {
        var alvo = e.target.closest && e.target.closest('button');
        if (alvo) setTimeout(guardar, 0);          // escolha de combobox só entra depois do clique
      }, true);

      var obs = new MutationObserver(function (muts) {
        ligarMascaraCnpj(sr);
        muts.forEach(function (m) {
          if (m.type === 'characterData') traduzirNo(m.target);
          m.addedNodes.forEach(function (n) {
            if (n.nodeType === 3) traduzirNo(n);
            else if (n.nodeType === 1) traduzirTudo(n);
          });
        });
        if (!aviso || !link || aviso.classList.contains('is-on')) return;
        var semForm = !sr.querySelector('form');
        var texto = sr.textContent || '';
        if (!semForm && !/obrigad|sucesso|recebemos|enviado|thank you/i.test(texto)) return;
        if (!memoria.length) return;
        var url = montarLink(raiz, memoria);
        if (!url) return;
        link.href = url;
        aviso.classList.add('is-on');
        log('link do WhatsApp pronto');
        if (raiz.dataset.waAuto === 'true') window.open(url, '_blank', 'noopener');
      });
      obs.observe(sr, { childList: true, subtree: true, characterData: true });
    });
  }

  function iniciar() { document.querySelectorAll('[data-fa-root]').forEach(ligar); }
  if (document.readyState !== 'loading') iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('[data-fa-root]') : null;
    if (r) { delete r.dataset.faLigado; ligar(r); }
  });
})();

